import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'

import Component from './component'

import withTranslation from '../../../globals/components/withTranslation'

export default compose(withTranslation, withRouter, connect())(Component)
